import withRequiredAdmin from '../../HOC/withRequiredAdmin';
import AdminReports from './AdminReports';

export default withRequiredAdmin(AdminReports);
